export const emptyHomepageIntro = () => ({
  title: '',
  time: '',
  eventText: '',
  downloadFile: '',
  downloadLabel: ''
});

export const normalizeHomepageIntro = (data = {}) => ({
  title: data.title || '',
  time: data.time || '',
  eventText: data.eventText || '',
  downloadFile: data.downloadFile || '',
  downloadLabel: data.downloadLabel || ''
});

export const getHomepageIntroSnapshot = (intro) =>
  JSON.stringify(normalizeHomepageIntro(intro));

export const hasHomepageIntroContent = (intro) =>
  Boolean(
    intro?.title?.trim()
      || intro?.time?.trim()
      || intro?.eventText?.trim()
      || intro?.downloadFile?.trim()
      || intro?.downloadLabel?.trim()
  );
